import { gql } from "@apollo/client";

export const ProfileClientRegion = gql`
    query ProfileClientRegion {
        profile {
            id
            client {
                id
                region {
                    id
                }
            }
        }
    }
`;
